<template>
    <DefaultHeader />
    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-12">
                <div class="card shadow my-2 p-3 bg-white rounded drive-history-header-card">
                    <div class="row g-4 align-items-stretch">
                        <div class="col-12 col-lg-5">
                            <div class="drive-history-intro">
                                <div class="drive-history-title">Historique des trajets</div>
                                <div class="drive-history-subtitle">Consultez les trajets enregistrés pour ce véhicule.
                                </div>
                                <div class="drive-history-vehicle-display">
                                    <VehicleNameDisplay :balise="baliseInfo" />
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-7">
                            <form class="drive-history-filters-card"
                                @submit.prevent="balisePagesDrives(); currentPage = 1; onPageChange(currentPage)">
                                <div class="drive-history-filters-head">
                                    <div class="drive-history-filters-title">Période</div>
                                    <div class="drive-history-filters-subtitle">Choisissez l’intervalle à afficher</div>
                                </div>

                                <div class="drive-history-filters-row">
                                    <div class="drive-filter-field">
                                        <label class="drive-filter-label" for="drive-start-date">Début</label>
                                        <input id="drive-start-date" class="form-control drive-filter-input" type="date"
                                            v-model="startDate" required>
                                    </div>

                                    <div class="drive-filter-field">
                                        <label class="drive-filter-label" for="drive-end-date">Fin</label>
                                        <input id="drive-end-date" class="form-control drive-filter-input" type="date"
                                            v-model="endDate" required>
                                    </div>

                                    <div class="drive-filter-actions">
                                        <button class="btn btn-primary drive-filter-submit" type="submit">
                                            Appliquer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-12 d-flex flex-column justify-content-between">
                <div class="card shadow mt-2 my-md-0 p-3 bg-white rounded">
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Départ</th>
                                    <th scope="col" class="text-end">Arrivée</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(baliseDrive, index) in baliseDrives" :key="index">
                                    <td class="drive-row" colspan="2">
                                        <router-link :to="'/drivepositions/' + baliseDrive.id"
                                            class="text-decoration-none">
                                            <FullDriveDisplay :baliseDrive="baliseDrive" />
                                        </router-link>
                                    </td>
                                    <td style="width: 100px;" class="drive-row">
                                        <MapLinkDisplay :link="'/drivemap/' + baliseDrive.id" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-center my-2">
                        <div class="row col-12 col-md-6">
                            <div class="d-flex justify-content-start">
                                <div class="col-8"><label for="resPerPage">Résultats par page :</label></div>
                                <div class="col-3"><select name="resPerPage" id="resPerPage" class="form-select"
                                        v-model="perPage"
                                        @change="setPerPage($event); currentPage = 1; onPageChange(currentPage)">
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                    </select></div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <nav aria-label="...">
                            <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
                                @pagechanged="onPageChange" />
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import FullDriveDisplay from '@/components/display/FullDriveDisplay.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import MapLinkDisplay from '@/components/display/MapLinkDisplay.vue'
import DrivesService from '@/services/drive.service'
import FormatHelper from '@/helpers/format.helper.js'
import BaliseService from '@/services/balise.service'
import Pagination from '@/components/PaginationComponent.vue'


export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        FullDriveDisplay,
        Pagination,
        VehicleNameDisplay,
        MapLinkDisplay
    },
    data() {
        return {
            baliseDrives: [],
            baliseInfo: [],
            drivesCount: null,
            pages: null,
            currentPage: 1,
            startResults: 0,
            perPage: 15,
            isEnd: false,
            displayEnd: false,
            startDate: null,
            endDate: null,
            totalPages: 0
        }
    },
    mounted() {
        this.balisePagesDrives()
        this.getBaliseInfos()
    },
    methods: {
        balisePagesDrives() {
            this.baliseDrives = []
            DrivesService.getBaliseDrives(this.$route.params.id, this.startResults, this.perPage, FormatHelper.dateFormatUTC(this.startDate), FormatHelper.dateFormatUTC(this.endDate, true))
                .then(response => {
                    this.baliseDrives = FormatHelper.baliseDrivesFormat(response.data.rows)
                    this.drivesCount = response.data.count
                    this.totalPages = Math.ceil(this.drivesCount / this.perPage)
                    console.log(this.drivesCount)
                })
        },
        onPageChange(page) {
            console.log(page)
            if (page > 1) {
                this.startResults = (page - 1) * this.perPage
            }
            else {
                this.startResults = 0
            }
            this.baliseDrives = []
            DrivesService.getBaliseDrives(this.$route.params.id, this.startResults, this.perPage, FormatHelper.dateFormatUTC(this.startDate), FormatHelper.dateFormatUTC(this.endDate, true))
                .then(response => {
                    this.baliseDrives = FormatHelper.baliseDrivesFormat(response.data.rows)
                })
            this.totalPages = Math.ceil(this.drivesCount / this.perPage)
            this.currentPage = page
        },
        getBaliseInfos() {
            BaliseService.getBaliseInfo(this.$route.params.id)
                .then(response => {
                    this.baliseInfo = FormatHelper.baliseInfoFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        setPerPage(event) {
            this.perPage = event.target.value
            this.totalPages = Math.ceil(this.drivesCount / this.perPage)
        },
        getDuration(startDate, endDate) {

            console.log(typeof startDate)
            console.log(typeof endDate)
            //const timeDifference = new Date(startDate).getTime() - new Date(endDate).getTime();
            //const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24))

            return startDate;
        }
    }
}
</script>

<style scoped>
.drive-row {
    cursor: pointer;
}

.drive-row:hover {
    background: #d2edfa;
    border-radius: 10px;
    border-style: none;
}

.drive-history-header-card {
    border: 1px solid #d9e2ec;
    border-radius: 16px !important;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08) !important;
}

.drive-history-intro {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.drive-history-vehicle-wrap {
    min-width: 0;
}

.drive-history-title {
    color: #0f172a;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.25;
}

.drive-history-subtitle {
    margin-top: 0.2rem;
    color: #64748b;
    font-size: 0.85rem;
    line-height: 1.35;
}

.drive-history-vehicle-display {
    margin-top: 0.9rem;
     min-width: 0;
    max-width: 100%;
}

.drive-history-filters-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #fbfdff;
    gap: 0.7rem;
}

.drive-history-filters-head {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 0;
    gap: 0.15rem;
}

.drive-history-filters-title {
    color: #0f172a;
    font-size: 0.88rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.drive-history-filters-subtitle {
    color: #64748b;
    font-size: 0.85rem;
    line-height: 1.35;
}

.drive-history-filters-row {
    display: grid;
    grid-template-columns: minmax(170px, 1fr) minmax(170px, 1fr) auto;
    gap: 0.75rem;
    align-items: end;
}

.drive-filter-field {
    min-width: 0;
}

.drive-filter-label {
    display: inline-block;
    margin-bottom: 0.25rem;
    color: #64748b;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.drive-filter-input {
    min-height: 40px;
    border: 1px solid #d5dee8;
    border-radius: 10px;
    box-shadow: none !important;
    background: #fff;
}

.drive-filter-input:focus {
    border-color: #86b7fe;
}

.drive-filter-actions {
    display: flex;
    align-items: end;
}

.drive-filter-submit {
    min-height: 40px;
    padding: 0.5rem 1rem;
    border-radius: 10px;
    font-weight: 600;
    white-space: nowrap;
}

@media (max-width: 991.98px) {
    .drive-history-filters-row {
        grid-template-columns: 1fr 1fr;
    }

    .drive-filter-actions {
        grid-column: 1 / -1;
    }

    .drive-history-filters-card {
        padding: 0.9rem;
    }
}

@media (max-width: 767.98px) {
    .drive-history-filters-row {
        grid-template-columns: 1fr;
    }

    .drive-filter-actions {
        grid-column: auto;
    }

    .drive-filter-submit {
        width: 100%;
    }
}
</style>